import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const CorePickerStarCross: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="M16 0h8v8h-8zm0 32h8v8h-8zM8 8h8v8H8zm16 0h8v8h-8zM8 24h8v8H8zm16 0h8v8h-8zM0 16h8v8H0zm32 0h8v8h-8z" />
      </g>
    </svg>
  </IconWrap>
);
CorePickerStarCross.displayName = 'CorePickerStarCross';

export default CorePickerStarCross;
